import router from './router'
import RoleMessages from './localization'

export default {
  router,
  localization: RoleMessages,
}
